module.exports = __webpack_public_path__ + "static/media/logo_color_white.df67e36c.png";